import { loadable } from "@faire/retailer/lib/loadable";
import { handleComponentLoadError } from "@faire/retailer/lib/loadChunkErrors";

export const LazyProductLayoutElement = loadable(
  () => import("./ProductLayoutElements").catch(handleComponentLoadError),
  { resolveComponent: (m) => m.ProductLayoutElements }
);
